import React from 'react';

class ThankYou extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var twttr = window.twttr || { widgets: { load: function() {} } };
    twttr.widgets.load();
  }

  render() {
    return (
      <div className="step-container step-six">
        <h2>Thanks!</h2>
        <p>Check your inbox for a link to your Better Error Pages download!</p>
        <p>
          Think Better Error Pages is a nifty little tool? Share it on Twitter.
        </p>
        <a
          href="https://twitter.com/share"
          className="twitter-share-button"
          data-url="https://better-error-pages.statuspage.io/"
          data-text="Better Error Pages: build free 404, 500-level, and maintenance pages in 60 seconds."
          data-via="statuspageio"
          data-size="large"
        >
          Tweet
        </a>
      </div>
    );
  }
}

export default ThankYou;
